export default __webpack_public_path__ + "static/media/renault.ea50c93c.svg";